import { useState } from "react";
import { C } from "../../constants/theme";

const PARTS = [
  { key:"ruh",    zone:"root",     icon:"🌙", label:"Ruh", arabic:"Spirit", color:"#128F82",
    title:"Root — Ruh · Spirit", body:"The unseen foundation everything else grows from: Qur'an, du'as, Seerah, and a child's sense of who they are in front of Allah. Every day begins and ends with Him." },
  { key:"aql",    zone:"trunk",    icon:"🧠", label:"Aql", arabic:"Mind", color:"#1B3F8B",
    title:"Trunk — Aql · Mind", body:"The structure that carries growth upward: English, Urdu, and Arabic woven through every activity. Mathematics begins with hands, never pencils." },
  { key:"qalb",   zone:"branches", icon:"💚", label:"Qalb", arabic:"Heart", color:"#E2748F",
    title:"Branches — Qalb · Heart", body:"Reaching outward to others: social-emotional development — sharing, empathy, and self-control. Feelings are understood here, not managed." },
  { key:"jism",   zone:"leaves",   icon:"🌿", label:"Jism", arabic:"Body", color:"#6CB566",
    title:"Leaves — Jism · Body", body:"Always renewing, always in motion: outdoor time, movement, and physical classes. The body is an Amanah from Allah — we treat it that way." },
  { key:"yadayn", zone:"fruit",    icon:"🤲", label:"Yadayn", arabic:"Hands", color:"#F0AE1E",
    title:"Fruit — Yadayn · Hands", body:"The visible outcome everyone can see: drawing, role play, crafts — the hands-on work a child carries home, and the fruit of everything growing beneath it." },
];

const NafsTree = () => {
  const [active, setActive] = useState("ruh");
  const current = PARTS.find(p => p.key === active);
  const dim = (zone) => (active && PARTS.find(p => p.zone === zone)?.key !== active ? 0.35 : 1);
  const glow = (zone) => PARTS.find(p => p.zone === zone)?.key === active;

  return (
    <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(300px,1fr))", gap:40, alignItems:"center" }}>
      <div style={{ position:"relative" }}>
        <svg viewBox="0 0 400 440" width="100%" xmlns="http://www.w3.org/2000/svg">
          {/* fruit dots */}
          <g
            onClick={() => setActive("yadayn")}
            onMouseEnter={() => setActive("yadayn")}
            style={{ cursor:"pointer", opacity: dim("fruit"), transition:"opacity 0.3s ease" }}
          >
            {glow("fruit") && <circle cx="200" cy="70" r="120" fill="#F0AE1E" opacity="0.08" />}
            <circle cx="78" cy="82" r="9" fill="#F0AE1E"/>
            <circle cx="112" cy="60" r="8" fill="#F0AE1E"/>
            <circle cx="322" cy="82" r="9" fill="#F0AE1E"/>
            <circle cx="288" cy="60" r="8" fill="#F0AE1E"/>
            <circle cx="200" cy="30" r="9" fill="#F0AE1E"/>
            <circle cx="72" cy="132" r="8" fill="#F0AE1E"/>
            <circle cx="328" cy="132" r="8" fill="#F0AE1E"/>
          </g>

          {/* leaves */}
          <g
            onClick={() => setActive("jism")}
            onMouseEnter={() => setActive("jism")}
            style={{ cursor:"pointer", opacity: dim("leaves"), transition:"opacity 0.3s ease" }}
          >
            <ellipse cx="82" cy="88" rx="42" ry="30" fill="#6CB566"/>
            <ellipse cx="118" cy="66" rx="30" ry="22" fill="#4E9647"/>
            <ellipse cx="318" cy="88" rx="42" ry="30" fill="#6CB566"/>
            <ellipse cx="282" cy="66" rx="30" ry="22" fill="#4E9647"/>
            <ellipse cx="200" cy="40" rx="46" ry="34" fill="#6CB566"/>
            <ellipse cx="74" cy="138" rx="32" ry="22" fill="#4E9647" opacity="0.9"/>
            <ellipse cx="326" cy="138" rx="32" ry="22" fill="#4E9647" opacity="0.9"/>
          </g>

          {/* branches */}
          <g
            onClick={() => setActive("qalb")}
            onMouseEnter={() => setActive("qalb")}
            style={{ cursor:"pointer", opacity: dim("branches"), transition:"opacity 0.3s ease" }}
          >
            <path d="M195,150 C160,120 130,100 82,88"  stroke="#E2748F" strokeWidth="7" fill="none" strokeLinecap="round"/>
            <path d="M190,162 C150,155 110,150 74,138" stroke="#E2748F" strokeWidth="7" fill="none" strokeLinecap="round"/>
            <path d="M205,150 C240,120 270,100 318,88" stroke="#E2748F" strokeWidth="7" fill="none" strokeLinecap="round"/>
            <path d="M210,162 C250,155 290,150 326,138" stroke="#E2748F" strokeWidth="7" fill="none" strokeLinecap="round"/>
          </g>

          {/* trunk */}
          <g
            onClick={() => setActive("aql")}
            onMouseEnter={() => setActive("aql")}
            style={{ cursor:"pointer", opacity: dim("trunk"), transition:"opacity 0.3s ease" }}
          >
            <path d="M200,140 C200,105 200,70 200,40" stroke="#E2748F" strokeWidth="8" fill="none" strokeLinecap="round"/>
            <path d="M182,300 C179,255 184,195 191,150 L209,150 C216,195 221,255 218,300 Z" fill="#1B3F8B"/>
          </g>

          <ellipse cx="200" cy="302" rx="130" ry="10" fill="#E4D2A6" opacity="0.6"/>

          {/* roots */}
          <g
            onClick={() => setActive("ruh")}
            onMouseEnter={() => setActive("ruh")}
            style={{ cursor:"pointer", opacity: dim("root"), transition:"opacity 0.3s ease" }}
          >
            <path d="M197,300 C168,318 145,338 122,362" stroke="#128F82" strokeWidth="7" fill="none" strokeLinecap="round"/>
            <path d="M199,300 C188,326 172,350 158,378" stroke="#128F82" strokeWidth="7" fill="none" strokeLinecap="round"/>
            <path d="M203,300 C214,326 230,350 244,378" stroke="#128F82" strokeWidth="7" fill="none" strokeLinecap="round"/>
            <path d="M203,300 C232,318 255,338 278,362" stroke="#128F82" strokeWidth="7" fill="none" strokeLinecap="round"/>
            <circle cx="122" cy="362" r="6" fill="#128F82"/>
            <circle cx="158" cy="378" r="6" fill="#128F82"/>
            <circle cx="244" cy="378" r="6" fill="#128F82"/>
            <circle cx="278" cy="362" r="6" fill="#128F82"/>
          </g>
        </svg>
        <div style={{ textAlign:"center", fontFamily:"Nunito", fontStyle:"italic", fontSize:12.5, color:C.muted, marginTop:-8 }}>
          Tap or hover a part of the tree
        </div>
      </div>

      <div>
        <div style={{ display:"flex", gap:8, flexWrap:"wrap", marginBottom:20 }}>
          {PARTS.map(p => (
            <button
              key={p.key}
              onClick={() => setActive(p.key)}
              style={{
                background: active === p.key ? p.color : C.white,
                color: active === p.key ? C.white : p.color,
                border:`2px solid ${p.color}`,
                fontFamily:"Nunito", fontWeight:800, fontSize:12.5,
                padding:"8px 16px", borderRadius:100,
                cursor:"pointer", transition:"all 0.25s ease",
                boxShadow: active === p.key ? `0 4px 14px ${p.color}45` : "none",
              }}
            >{p.icon} {p.label}</button>
          ))}
        </div>
        <div style={{
          background: C.white, borderRadius:22, padding:"28px 26px",
          border:`2px solid ${current.color}30`, boxShadow:"0 8px 26px rgba(0,0,0,0.06)",
          minHeight:150, transition:"border 0.3s ease",
        }}>
          <div style={{ fontFamily:"Fredoka One", fontSize:20, color:current.color, marginBottom:4 }}>{current.title}</div>
          <div style={{ fontFamily:"Lora", fontStyle:"italic", fontSize:12.5, color:C.muted, marginBottom:14 }}>{current.arabic}</div>
          <p style={{ fontFamily:"Nunito", fontSize:14.5, color:C.text, lineHeight:1.8, margin:0 }}>{current.body}</p>
        </div>
      </div>
    </div>
  );
};

export default NafsTree;
